import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../config/app.config';

@Injectable()
export class EnumerationService {
  constructor(
    @Inject(AppConfig) private appConfig,
    protected http: HttpClient,
  ) {

  }

  get(identifier, assignmentId = '') {
    return this.http.get(`${this.appConfig.apiUrl}/enumeration/${identifier}/${assignmentId}`).map((response: any) => {
      return response;
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/enumeration/enumeration.service.ts